export const amapH5Key = (import.meta.env.VITE_APP_AMAP_H5_KEY || '').trim()
export const miniProgramMapKey = (import.meta.env.VITE_APP_MP_MAP_KEY || '').trim()

export const applyH5MapConfig = () => {
  // uni H5 map reads the provider key from __uniConfig at runtime.
  // #ifdef H5
  const uniConfig = globalThis.__uniConfig
  if (uniConfig && amapH5Key) {
    uniConfig.aMapKey = amapH5Key
  }
  // #endif
}
